import React, {PropTypes, Component} from 'react';
import {Link} from 'react-router';


class UserStatusModal extends Component {

    handleClose = (event) => {
        if (event.target == this.refs.wrapper || event.target == this.refs.close) {
            this.props.modalActions.closeModal();
        }
    };

    renderStatuses = () => {
        return this.props.statuses.map((status, index) => {
                return (
                    <li className="status-list__item" key={index}
                        onClick={this.props.handleSetHomeStatus.bind(null, status)}>
                        {status}
                    </li>
                );
            }
        );
    };

    render() {
        return (
            <div ref="wrapper" className="modal" onClick={this.handleClose}>
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="modal-header__title">Select Profile</div>
                        <div ref="close" className="modal-header__close" onClick={this.handleClose}></div>
                    </div>
                    <div className="modal-body">
                        <ul className="status-list">
                            {this.renderStatuses()}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

UserStatusModal.PropTypes = {
    statuses: PropTypes.array,
    handleSetHomeStatus: PropTypes.func
};

export default UserStatusModal;



// WEBPACK FOOTER //
// ./app/components/pages/service/modals/UserStatus.modal.page.jsx